import React from 'react';
import { competenceProfileMap, CompetenceType } from '@domain/constant/acca/test/result/competenceType';
import classNames from 'classnames/bind';
import styles from './synergyCard.module.scss';

const cx = classNames.bind(styles);

interface SynergyCardProps {
  title: string;
  type: CompetenceType;
}

const SynergyCard = ({ type, title }: SynergyCardProps) => {
  const { name, type: typeEnglish, img } = competenceProfileMap[type];

  return (
    <div className={cx('card')}>
      <em className={cx('title')}>{title}</em>
      <span className={cx('joy')} style={{ backgroundImage: `url(/img/components/acca/test/result${img})` }} />
      <div className={cx('typeWrap')}>
        <em className={cx('typeText')}>{name}</em>
        <span className={cx('typeEnglish')}>{typeEnglish}</span>
      </div>
    </div>
  );
};

export default SynergyCard;
